import { Pagination, Stack } from '@mui/material';
import React from 'react'
import { TABLE_ROWS_NUMBER } from '../../../../utils/constants/tables';
import { useSelector } from 'react-redux';


const CorePagination = ({ page, setPage, totalPages }) => {

    const colorPrimary = useSelector((state) => state.app.primaryColor);


    const handlePageChange = (event, value) => {
        setPage({
            currentPage: value,
            startRow: (value - 1) * TABLE_ROWS_NUMBER,
            endRow: value * TABLE_ROWS_NUMBER - 1,
        });
    };

    return (
        <Stack spacing={2} className="mt-4">
            <Pagination
                count={totalPages}
                page={page.currentPage}
                onChange={handlePageChange}
                disabled={totalPages === 1}
                sx={{
                    '& .Mui-selected': {
                        backgroundColor: totalPages === 1 ? '' : `${colorPrimary} !important`, // Colore personalizzato per il numero di pagina selezionato
                        color: '#fff', // Colore del testo della pagina selezionata
                    },
                }}
            />
        </Stack>
    )
}

export default CorePagination